import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Bank(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Bank", sx, viewBox, children: [
    /* @__PURE__ */ jsx("path", { d: "M13.4655 20.7552h-3.1742v14.8131h3.1742V20.7552Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.5823 17.5811v3.5269c0 .2338-.0975.4581-.2711.6235-.1736.1653-.4091.2582-.6547.2582H9.1016c-.24554 0-.48103-.0929-.65465-.2582-.17363-.1654-.27117-.3897-.27117-.6235v-3.5269h7.40652Zm0 21.1616v-3.527c0-.2338-.0975-.4581-.2711-.6234-.1736-.1654-.4091-.2583-.6547-.2583H9.1016c-.24554 0-.48103.0929-.65465.2583-.17363.1653-.27117.3896-.27117.6234v3.527h7.40652Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M26.1625 20.7554h-3.1742v14.8131h3.1742V20.7554Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.2777 17.5811v3.5269c0 .2338-.0976.4581-.2712.6235-.1736.1653-.4091.2582-.6547.2582h-5.5549c-.2455 0-.481-.0929-.6546-.2582-.1737-.1654-.2712-.3897-.2712-.6235v-3.5269h7.4066Zm0 21.1616v-3.527c0-.2338-.0976-.4581-.2712-.6234-.1736-.1654-.4091-.2583-.6547-.2583h-5.5549c-.2455 0-.481.0929-.6546.2583-.1737.1653-.2712.3896-.2712.6234v3.527h7.4066Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M38.8578 20.7554h-3.1742v14.8131h3.1742V20.7554Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.9749 17.581v3.5269c0 .2339-.0975.4582-.2711.6235-.1737.1654-.4092.2583-.6547.2583h-5.5549c-.2456 0-.481-.0929-.6547-.2583-.1736-.1653-.2711-.3896-.2711-.6235V17.581h7.4065Zm0 21.1616v-3.5269c0-.2339-.0975-.4582-.2711-.6235-.1737-.1654-.4092-.2583-.6547-.2583h-5.5549c-.2456 0-.481.0929-.6547.2583-.1736.1653-.2711.3896-.2711.6235v3.5269h7.4065Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42.184 38.7425H5.90693c-.50089 0-.90693.3553-.90693.7936v1.5871c0 .4383.40604.7936.90693.7936H42.184c.5009 0 .9069-.3553.9069-.7936v-1.5871c0-.4383-.406-.7936-.9069-.7936ZM24.0455 7 5 12.3381v5.2427h38.0909v-5.2427L24.0455 7Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Bank.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Bank"
};
validateTidalLicense();
export {
  Bank
};
//# sourceMappingURL=Bank.js.map
